/**
 * One in-flight request per key. A second call waits on the first.
 * The slot frees when that request resolves or fails, then the next call runs.
 * The request itself is not cut short, so a slow response still completes.
 */

const inflight = new Map<string, Promise<unknown>>();

export function singleFlight<T>(key: string, run: () => Promise<T>): Promise<T> {
  // ---------------------------------------------------------------
  // step 1: Reuse the request already in flight for this key
  // ---------------------------------------------------------------
  const existing = inflight.get(key);
  if (existing) return existing as Promise<T>;

  // ---------------------------------------------------------------
  // step 2: Free the slot when that request resolves or fails
  // ---------------------------------------------------------------
  const task = run().finally(() => {
    if (inflight.get(key) === task) inflight.delete(key);
  });
  inflight.set(key, task);
  return task;
}
